function getFileNameFromContentDispositionHeader(contentDispositionHeader) {
    const regex = /filename="(.*?)"/g
    const match = regex.exec(contentDispositionHeader)
    if (!match || !match[1] || match[1] === '') {
        return null
    }
    return match[1]
}

export { getFileNameFromContentDispositionHeader }
